import { render } from "./CoachItem.vue?vue&type=template&id=3a4c9d58&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=3a4c9d58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a4c9d58"

export default script